import service from '../utils/axios'

// post
export function uploadFile(formData) {
  return service.post('/resource/oss/upload', formData, {
    headers: {
      Authorization: sessionStorage.getItem('Authorization'),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}
